<template>

    <div class="row">

 <div id="contract-menu" class="col-lg-12 col-xl-3 d-none">
        <div class="card m-b-30">
          <div class="card-body">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-product-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link mb-2 active"
                id="v-pills-general-tab"
                data-toggle="pill"
                href="#v-pills-general"
                role="tab"
                aria-controls="v-pills-general"
                aria-selected="true"
              >
                <i class="feather icon-info mr-2"></i>Generale
              </a>
              
            </div>
          </div>
        </div>
      </div>
<div class="col-lg-12 col-xl-12" id="contract-tabs" >
     <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                                <form @submit.prevent="save" v-if="entity">
                                    <div class="row">
                                        
                                          <div class="col-12">

                                              <div class="form-group">
                                                    <label class="col-form-label" for="descrizione">Titolo</label>
                                                    <input type="text" id="descrizione" name="descrizione" placeholder="Nome" v-model="entity.name" class="form-control" >
                                                    <!--<span >{{ errors[0] }}</span>-->
                                              </div>
                                        </div>
                                    
                                   
                                       <div class="col-12">
                                          <label class="col-form-label" for="descrizione">Contenuto</label>
                                      
                                          <editor v-if="entity.name.indexOf('.subject')<0 &&  entity.name.indexOf('.to')"
              :api-key="tinyKey"
              tinymceScriptSrc="/tinymce_7.1.0/tinymce/js/tinymce/tinymce.min.js"
              :init="{
                height: 500,
                menubar: false,
                plugins: [
                'advlist','autolink','lists','link','image','charmap','print','preview','anchor',
      'searchreplace','visualblocks','code','fullscreen',
'insertdatetime','media','table','paste','code','help','wordcount'
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
              }"
              v-model="entity.content"
            ></editor>
            <textarea v-else class="form-control" v-model="entity.content"></textarea>
                                            </div>

                                    </div>




                                        <div class="form-group mt-3">
                                            <button type="button" class="btn btn-xs  btn-primary-rgba mr-2" v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                            <button type="button" class="btn btn-xs  btn-danger-rgba  mr-2" v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                        </div>
</form>
                               
                        
                
                </div>
            </div>
        </div>
              </div>
          

              <div
                class="tab-pane fade"
                id="v-pills-attachments"
                role="tabpanel"
                aria-labelledby="v-pills-attachments-tab"
              >
              <attachments :value="$route.params.id" :customtypes= customTypes />
              </div>
          </div>
     </div>
       </div>
</div>
    </div>


</template>

<script>
import vueselect from 'vue-select'
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import { Chrome } from 'vue-color';
 
    export default {
        data() {
            return {
                entity: null,
                colors: '#FFFFFF',
               categories:[],
              customTypes: [{"attachmentTypeId":"documentazione-varia","name":"Documentazione varia"}]
            };
        },
        computed: {
          
    cuser() {
      return this.$store.state.user;
    },
            tinyKey: function () {
                return window.SETTINGS.TinyApiKey;
            }
        },
        components: {
            Editor,vueselect
        },
        name: 'templateSave',
        beforeMount() {
            this.loaddata();


        },
        methods: {
            loaddata(){
var me = this;
 axios.get("templatecategory/list").then(response => {
this.categories = response.data;

 
            axios.get("template/" +( me.$route.params.id ||'')).then(response => {
               response.data.enableCompanies = response.data.enableCompanies.filter(x=>x!="*");
               response.data.enableStates = response.data.enableStates.filter(x=>x!="*");
                                if( response.data.enableCompanies.length == 0)  response.data.enableCompanies = null;
                                me.entity = response.data;
                                me.entity.isEmailTemplate = true;
                                me.entity.name =  me.entity.name || "";
                                if(me.entity.name && me.entity.name!=''){
 me.$store.state.breadCrump.title = me.entity.name;

                                }
            });

});
            },
            cancel() {
                this.$router.push({
                    name: "route-emailtemplate-list",

                    replace: true
                });
            },
           
              updateFromPicker(color) {
                this.entity.backgroundColor = color.hex;
            },
            save() {
                
                let me = this;
                if(this.entity.enableCompanies==null || this.entity.enableCompanies.length ==0){
                    this.entity.companies ="*";
                }else{
                   
                    this.entity.companies = this.entity.enableCompanies.join(",");
                   
                }
               
                 if(this.entity.companies == "")
                        this.entity.companies ="*";
                axios.post("template", this.entity).then(response => {
                    if (me.$route.params.id != response.data.templateId) { me.$router.push({ name: 'route-emailtemplate-edit', params: { id: response.data.templateId } }); }

                    me.$swal(
                                    {
                                        title: "Salvataggio avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-top"
                        });
                })
            }
        }
    };
</script>
